export default __webpack_public_path__ + "assets/ico_contract_sm-c44f3b5a.svg";